<template>
  <div class="goods" v-if="!offline">
    <van-nav-bar left-arrow @click-left="onClickLeft" title="商品详情" />
    <div class="subject">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        style="width: 100%;height: 200px"
        :height="500"
      >
        <van-swipe-item
          v-for="(goo, index) in lbtList"
          :key="index"
        >
          <img style="width: 100%;" v-lazy="goo.mpPath" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-cell-group>
      <van-cell label="描述信息">
        <div class="goods-title">{{ goods.spName }}</div>
        <div class="goods-desc">{{ goods.spContent }}</div>
        <div class="goods-price">￥{{ goods.je }}</div>
      </van-cell>
    </van-cell-group>

    <van-goods-action>
      <van-goods-action-icon icon="home-o" @click="toHome" text="主页" />
      <van-goods-action-icon
        icon="star-o"
        @click="like"
        :color="likeColor"
        text="收藏"
      />
      <van-goods-action-button  color="#2f72f3"  type="danger" @click="addCart" text="立即购买" />
    </van-goods-action>
    <van-sku
      v-model="showSku"
      :sku="sku"
      :goods="goods"
      :goods-id="goods.id"
      :hide-stock="sku.hide_stock"
      @buy-clicked="onBuyClicked"
      :show-add-cart-btn="false"
    />
  </div>
  <div class="offline" v-else>
    <p style="text-align: center; color: lightgray">
      <van-icon name="warning-o" style="text-align: center" size="3rem" /><br />
      该商品已下架
    </p>
    <van-button type="primary" block round @click="toHome"
      >去看看其他商品</van-button
    >
  </div>
</template>

<script>
import {
  Button,
  Cell,
  CellGroup,
  Col,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  Icon,
  NavBar,
  Sku,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Tag,
  Toast,
} from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Sku.name]: Sku,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [NavBar.name]: NavBar,
  },

  data() {
    return {
      ifLike: false,
      likeColor: "black",
      cartCount: "",
      showSku: false,
      sku: {
        tree: [
          {
            k: "颜色", // skuKeyName：规格类目名称
            k_s: "s1", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "0", // skuValueId：规格值 id
                name: "红色", // skuValueName：规格值名称
                //   imgUrl: require('./../../assets/img/2.jpg'), // 规格类目图片，只有第一个规格类目可以定义图片
                //  previewImgUrl: require('./../../assets/img/2.jpg') // 用于预览显示的规格类目图片
              },
            ],
          },
        ],
        list: [],
        price: "12.25", // 默认价格（单位元）
        stock_num: 100000, // 商品总库存
        collection_id: 1, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: true, // 是否无规格商品
        hide_stock: true, // 是否隐藏剩余库存
      },
      offline: false,
      lbtList: "",
      // 展示商品信息
      goods: {
        id: 1,
        name: "",
        price: 25.26,
        express: "免运费",
        remain: 0,
        thumb: [],
        descript: "这是一个测试商品",
        stock: 255,
      },
    };
  },
  created() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      // 通过商品id获取商品详情
      let goodId = this.$route.query.id;
      sessionStorage.setItem("goodId",goodId);
      let _this = this;
      this.$axios
        .post("/memberBusiness/order/merchpictureList", { merchantId: goodId })
        .then((data) => {
          this.fileListse = [];

          this.lbtList = data.data;
          //  dat.forEach((item) => {
          //     this.lbtList.push({ url: item.mpPath, id: item.id });
          // });
        })
        .catch(
          function (response) {
            this.$message.error("操作失败请重试");
          }.bind(this)
        );
      let url =
        "/index/" +
        goodId +
        "/" +
        sessionStorage.getItem("id") +
        "/productDetails";
      return new Promise((resolve, reject) => {
        _this.$axios
          .get(url)
          .then((data) => {
            this.goods = data.data;
            this.goods.picture = data.data.productPicture; //用于弹开图片显示
            this.sku.price = this.goods.je;
            this.likeColor = this.goods.loveFlag;
          })
          .catch((erro) => {});
      });
    },
    toHome() {
      this.$router.push("/home");
    },
    formatPrice() {
      return "¥" + (this.goods.price / 100).toFixed(2);
    },

    goToCart() {
      this.$router.push("/cart");
    },
    addCart() {
      this.showSku = true;
    },
    buy() {
      this.showSku = true;
    },
    sorry() {
      Toast("敬请期待");
    },
    like() {
      //喜欢的商品
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中...",
      });
      const url = "/memberBusiness/spxx/" + this.goods.id + "/updateGoodsLove";
      this.$axios
        .post(url)
        .then((data) => {
          Toast({
            message: data.message,
            position: "middle",
            duration: 2000,
          });

          if (data.code == 200) {
            this.likeColor = data.data;
          }
          Toast.clear();
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
          Toast.clear();
        });
    },
    onBuyClicked(skuData) {
      //立即购买

      // let cartData = {id:skuData.goodsId,idSku:this.sku.none_sku?'':skuData.selectedSkuComb.id,je:skuData.selectedSkuComb.price/100,introductionPicture:this.goods.picture,spStatus:skuData.selectedNum,spContent: this.goods.spContent,spName:this.goods.spName}

      let cartData = {
        name: this.goods.spName,
        descript: this.goods.descript,
        id: skuData.goodsId,
        idSku: this.sku.none_sku ? "" : skuData.selectedSkuComb.id,
        price: this.goods.je,
        picture: this.goods.picture,
        count: skuData.selectedNum,
        isContract: this.goods.isContract,
      };
      let cardDataToSession = [];
      cardDataToSession.push(cartData); //放入对象数组
      sessionStorage.setItem("buyData", JSON.stringify(cardDataToSession));
      this.$router.push({ path: "/checkout" });
    },
    onClickLeft() {
      //this.$router.go(-1)
      this.$router.push({ path: "/home" });
    },
    onAddCartClicked(skuData) {
      // 加入购物车
      let cartData = {
        name: this.goods.spName,
        descript: this.goods.descript,
        id: skuData.goodsId,
        idSku: this.sku.none_sku ? "" : skuData.selectedSkuComb.id,
        price: this.goods.je,
        picture: this.goods.picture,
        count: skuData.selectedNum,
      };
      const url = "/memberBusiness/car/updateCar";
      this.$axios
        .post(url, cartData)
        .then((data) => {
          Toast({
            message: data.message,
            position: "middle",
            duration: 2000,
          });
          if (data.code == 200) {
            this.showSku = false;
          }
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });
    },
    submit() {
      // alert(5);
      this.$router.push({
        path: "/checkout",
        query: { ids: this.checkedCartItem },
      });
    },
  },
};
</script>

<style lang="less" scoped>




img {
  width: 100%;
  height: 40%;
}

.section-detail {
  margin-top: -4px;
}
.like-info {
  color: black;
}

.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      height: 450px;
      display: block;
    }
  }

  &-desc {
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    line-height: 18px;
    margin: 6px 0;
  }

  &-detail {
    padding: 15px;
    font-size: 14px;
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
.offline {
  margin-top: 60%;
}
</style>
